<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-2">
        <label>Usar dados do Beneficiário</label>
        <vs-switch
          class="mb-3"
          v-model="usarDadosAssociado"
          style="width: 60px"
        >
          <span slot="on">Sim</span>
          <span slot="off">Não</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Nome do condutor"
          v-model="form.nome"
          name="Nome"
          v-validate="{ required: true }"
          :state="validateState('Nome')"
          :danger="validateClass('Nome')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="CPF"
          v-mask="'###.###.###-##'"
          v-model="form.cpf"
          name="CPF"
          v-validate="{ required: true, min: 14 }"
          :state="validateState('CPF')"
          :danger="validateClass('CPF')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="RG"
          v-model="form.rg"
          name="RG"
          v-validate="{ required: true }"
          :state="validateState('RG')"
          :danger="validateClass('RG')"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Telefone"
          v-mask="'(##) ####-####'"
          v-model="form.telefone"
          name="Telefone"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Celular"
          v-mask="'(##) #####-####'"
          v-model="form.celular"
          name="Celular"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNH"
          v-mask="'###########'"
          v-model="form.cnh"
          name="CNH"
          v-validate="{ required: true, min: 11 }"
          :state="validateState('CNH')"
          :danger="validateClass('CNH')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Vencimento CNH"
          v-mask="'##/##/####'"
          v-model="form.dataVencimentoCnh"
          name="Data de Vencimento CNH"
          v-validate="{ date_format: 'dd/MM/yyyy' }"
          :state="validateState('Data de Vencimento CNH')"
          :danger="validateClass('Data de Vencimento CNH')"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CEP"
          v-mask="'##.###-###'"
          v-model="form.cep"
          name="CEP"
          @keyup.native="keymonitor"
          v-validate="{ required: true, min: 10 }"
          :state="validateState('CEP')"
          :danger="validateClass('CEP')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Endereço"
          v-model="form.endereco"
          name="Endereço"
          v-validate="{ required: true }"
          :state="validateState('Endereço')"
          :danger="validateClass('Endereço')"
        />
      </div>
      <div class="vx-col sm:w-1/6 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número"
          v-model="form.numero"
          name="Número"
          v-validate="{ required: true }"
          :state="validateState('Número')"
          :danger="validateClass('Número')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Complemento"
          v-model="form.complemento"
          name="Complemento"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Bairro"
          v-model="form.bairro"
          name="Bairro"
          v-validate="{ required: true }"
          :state="validateState('Bairro')"
          :danger="validateClass('Bairro')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Estado"
          v-model="form.estado"
          name="Estado"
          v-validate="{ required: true }"
          :state="validateState('Estado')"
          :danger="validateClass('Estado')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Cidade"
          v-model="form.cidade"
          name="Cidade"
          v-validate="{ required: true }"
          :state="validateState('Cidade')"
          :danger="validateClass('Cidade')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../../services';
import locale from '../../../locale';
import moment from 'moment';
export default {
  props: ['dadosCondutor', 'formulario', 'dadosEvento'],
  watch: {
    dadosCondutor() {
      this.preencheForm();
    },
    usarDadosAssociado() {
      this.preencheForm();
    },
  },
  computed: {},
  components: {},
  data() {
    const form = {
      nome: null,
      cpf: null,
      rg: null,
      telefone: null,
      celular: null,
      cnh: null,
      dataVencimentoCnh: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      bairro: null,
      estado: null,
      cidade: null,
    };
    const usarDadosAssociado = false;
    return {
      form,
      usarDadosAssociado,
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitor: function () {
      if (this.form.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.form.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.form.endereco = res.data.street;
            this.form.bairro = res.data.neighborhood;
            this.form.cidade = res.data.city;
            this.form.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    dataVencimentoCnhFormatada(data) {
      return data.length === 10
        ? data
        : moment(data).utc().format('DD/MM/YYYY');
    },
    preencheForm() {
      let dados = this.dadosCondutor;
      if (this.usarDadosAssociado) {
        dados = this.dadosEvento.dadosAssociado;
      }
      if (dados) {
        this.form.nome = dados.nome;
        this.form.cpf = dados.cpf || dados.cpfcnpj;
        this.form.rg = dados.rg || dados.rgIe;
        this.form.cnh = dados.cnh;
        this.form.dataVencimentoCnh = this.dataVencimentoCnhFormatada(
          dados.dataVencimentoCnh,
        );
        this.form.telefone = dados.telefone;
        this.form.celular =
          dados.celular == null ? dados.telefone : dados.celular;
        this.form.cep = dados.cep;
        this.form.endereco = dados.endereco;
        this.form.numero = dados.numero;
        this.form.complemento = dados.complemento;
        this.form.bairro = dados.bairro;
        this.form.estado = dados.estado;
        this.form.cidade = dados.cidade;
      } else {
        this.form = {
          nome: null,
          cpf: null,
          rg: null,
          telefone: null,
          celular: null,
          cnh: null,
          dataVencimentoCnh: null,
          cep: null,
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          estado: null,
          cidade: null,
        };
      }
    },
    emitForm() {
      this.$emit('formAlterado', this.form);
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
  },
  created: function () {
    this.$watch('form', this.emitForm, {
      deep: true,
    });
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
